import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Endpoints } from './endpoints';
import {
  ApiClient,
  AuthenticatedUser,
  InternalUserLoginRequest,
  LoginAuthCodeRequest,
  NewPasswordRequest,
  RefreshSessionRequest,
} from '@pgaoc/shared-lib';

@Injectable({
  providedIn: 'root',
})
export class MemberAuthApi {
  private apiClient = inject(ApiClient);

  login(request: InternalUserLoginRequest): Observable<AuthenticatedUser> {
    return this.apiClient.post<AuthenticatedUser>(Endpoints.MemberAuth.login(), request);
  }

  resetPassword(memberId: number): Observable<void> {
    return this.apiClient.get<void>(Endpoints.MemberAuth.resetPassword(memberId));
  }

  submitMFACode(request: LoginAuthCodeRequest): Observable<AuthenticatedUser> {
    return this.apiClient.post<AuthenticatedUser>(Endpoints.MemberAuth.login(), request);
  }

  setNewPassword(memberId: number, request: NewPasswordRequest) {
    return this.apiClient.post<void>(Endpoints.MemberAuth.setNewPassword(memberId), request);
  }

  refreshSession(req: RefreshSessionRequest, currentUser: AuthenticatedUser): Observable<AuthenticatedUser> {
    const memberId = currentUser.id as number;
    return this.apiClient.post<AuthenticatedUser>(Endpoints.MemberAuth.refreshSession(memberId), req);
  }

  resendWelcomeEmail(email: string): Observable<void> {
    return this.apiClient.post<void>(Endpoints.MemberAuth.resendWelcomeEmail(email), {});
  }
}
